<template>
  <section
    v-if="mergeRequest"
    class="merge-request-card-short"
  >
    <i
      class="gf-icon gf-icon-exchange gf-fs-2"
      :style="{ color: mergeRequestColor }"
    ></i>
    <a :href="mergeRequestLink">#{{ mergeRequest?.localId }}</a>
    <span class="title">{{ mergeRequest?.title }}</span>
  </section>
</template>

<script>
export default {
  name: 'MergeRequestCardShort',
  props: {
    mergeRequest: {
      type: Object,
      default: null
    }
  },
  computed: {
    mergeRequestLink() {
      return `/project/${this.$route.params?.alias}/${this.$route.params?.projectAlias}/merge-request/${this.mergeRequest?.localId}`;
    },
    mergeRequestColor() {
      return `#${this.mergeRequest?.status?.hexColor}`;
    }
  }
};
</script>

<style lang="scss">
$this: '.merge-request-card-short';

#{$this} {
  padding: 6px;
  display: flex;
  gap: 4px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;

  & > a {
    text-decoration: underline;
  }

  & > .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
